import PostalCodeInput from './input';
import { onPostalCodeInputChangeEffect } from './effects';

export default PostalCodeInput;
export { onPostalCodeInputChangeEffect };
